import React, { useEffect, useSyncExternalStore } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { readRecovery } from '../../../util/readRecovery';

export default function ConnectionStatus() {
  const status = useSyncExternalStore(
    readRecovery.subscribe,
    readRecovery.getSnapshot
  );
  useEffect(() => readRecovery.start(), []);
  if (!status.offline && !status.failed) return null;
  let message = 'Unable to refresh this page’s data. Please try again.';
  if (status.offline)
    message = 'You’re offline. We’ll retry when your connection returns.';
  else if (status.retrying)
    message = 'Reconnecting — refreshing this page’s data…';
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 96, sm: 16 },
        left: 16,
        right: 16,
        mx: 'auto',
        maxWidth: 640,
        // The site's custom theme puts snackbars below its fixed cart bar.
        zIndex: (theme) =>
          Math.max(theme.zIndex.snackbar, theme.zIndex.modal + 1),
      }}
      data-test-id="connection-status"
    >
      <Alert
        severity={status.offline || status.retrying ? 'info' : 'warning'}
        role="status"
        action={
          status.failed && (
            <Button
              color="inherit"
              size="small"
              disabled={status.offline || status.retrying}
              onClick={() => readRecovery.retry()}
              data-test-id="connection-retry"
            >
              Retry
            </Button>
          )
        }
      >
        {message}
      </Alert>
    </Box>
  );
}
